import { message } from "antd";
import { promotionService } from "../services/promotions/index1";

const name = "promotions";
const initialState = {
  list: [],
  loading: {
    fetchList: false,
    create: false,
    fetch: false,
    update: false,
    delete: false,
  },
  total: 0,
  currentPromotion: {},
};

export const fetch = (id) => ({
  type: `${name}/fetch`,
  payload: id,
});

export const fetchList = (params) => ({
  type: `${name}/fetchList`,
  payload: params,
});
export const create = (data) => ({
  type: `${name}/create`,
  payload: data,
});

export const update = (id, data) => ({
  type: `${name}/update`,
  payload: { id, data },
});

export const remove = (id) => ({
  type: `${name}/remove`,
  payload: id,
});

export default {
  namespace: name,
  state: initialState,
  effects: {
    *remove({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "delete" });
      try {
        yield call(promotionService.remove, payload);
        yield put({
          type: "deletePromotion",
          payload,
        });
        message.success("Promotion deleted successfully");
      } catch (error) {
        console.error("Error deleting promotion:", error);
      }
      yield put({ type: "stopLoading", loadingType: "delete" });
    },
    *update({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "update" });
      try {
        const response = yield call(
          promotionService.update,
          payload.id,
          payload.data
        );
        yield put({
          type: "setCurrentPromotion",
          payload: response.data,
        });
        message.success("Promotion updated successfully");
      } catch (error) {
        console.error("Error updating promotion:", error);
      }
      yield put({ type: "stopLoading", loadingType: "update" });
    },
    *fetch({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      yield put({ type: "clearCurrentPromotion" });
      try {
        const response = yield call(promotionService.fetch, payload);
        yield put({ type: "setCurrentPromotion", payload: response.data });
      } catch (error) {
        yield put({ type: "clearCurrentPromotion" });
        console.error("Error fetching promotion by ID:", error);
      }
      yield put({ type: "stopLoading", loadingType: "fetch" });
    },
    *fetchList({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchList" });
      try {
        const response = yield call(promotionService.fetchList, payload);
        yield put({
          type: "setList",
          payload: {
            list: response.data.list,
            total: response.data.total,
          },
        });
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
      yield put({ type: "stopLoading", loadingType: "fetchList" });
    },
    *create({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "create" });
      try {
        const response = yield call(promotionService.create, payload);
        yield put({
          type: "addPromotion",
          payload: response.data,
        });
      } catch (error) {
        console.error("Error creating promotion:", error);
      }
      yield put({ type: "stopLoading", loadingType: "create" });
    },
  },
  reducers: {
    deletePromotion(state, { payload }) {
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload),
        total: state.total - 1,
      };
    },
    setList(state, { payload }) {
      return {
        ...state,
        list: [...state.list, ...payload.list],
        total: payload.total,
      };
    },
    addPromotion(state, { payload }) {
      return { ...state, list: [...state.list, payload] };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
    setCurrentPromotion(state, { payload }) {
      return { ...state, currentPromotion: payload };
    },
    clearCurrentPromotion(state) {
      return { ...state, currentPromotion: {} };
    },
  },
};
